const normalizeText = (value = "") => String(value || "").trim();
const getTimelinePlannerMetadata = (entry = {}) =>
  entry.metadata?.timelinePlanner || entry.timelinePlanner || {};

const getSectionIndex = (value = null) => {
  const index = Number(value);
  return Number.isInteger(index) ? index : null;
};

const getStorySummarySectionIndex = (entry = {}) =>
  getSectionIndex(
    getTimelinePlannerMetadata(entry)?.storySummary?.sourceSectionIndex ??
      entry.storySummary?.sourceSectionIndex,
  );

const getStoryChapterSectionIndex = (entry = {}) =>
  getSectionIndex(
    getTimelinePlannerMetadata(entry)?.storyChapter?.sourceSectionIndex ??
      entry.storyChapter?.sourceSectionIndex,
  );

export const isCanonicalStoryMomentEntry = (entry = {}) => {
  // A stored dailyLogs document is independently reachable, even if the planner
  // also used its section as the Story heading. Only unsaved summaries may fold away.
  if (entry.id && entry.collection === "dailyLogs") return true;
  const sourceContainerKind = normalizeText(
    entry.sourceContainerKind ||
      getTimelinePlannerMetadata(entry)?.sourceContainerKind ||
      getTimelinePlannerMetadata(entry)?.sourceContainer?.kind ||
      "",
  ).toLowerCase();

  if (sourceContainerKind !== "story") {
    return true;
  }

  const summarySectionIndex = getStorySummarySectionIndex(entry);
  const chapterSectionIndex = getStoryChapterSectionIndex(entry);

  if (summarySectionIndex === null || chapterSectionIndex === null) {
    return true;
  }

  return chapterSectionIndex !== summarySectionIndex;
};
